export function getApiErrorMessage(err: unknown, fallback: string): string {
  const error = err as { response?: { data?: { message?: string } } };
  return error?.response?.data?.message || fallback;
}
